import React from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';

const Pricing: React.FC = () => {
  return (
    <div className="pricing-page">
      {/* Header */}
      <section className="pricing-header section">
        <div className="container-narrow text-center">
          <h1 className="section-title">요금제</h1>
          <p className="section-subtitle">
            합리적인 가격으로 시작하세요<br />
            사용한 만큼만 지불하는 선불 크레딧 시스템
          </p>
        </div>
      </section>

      {/* Basic Plan */}
      <section className="basic-plan section">
        <div className="container">
          <div className="plan-card-large fade-in">
            <div className="plan-badge">1차 서비스</div>
            <div className="plan-header">
              <h2 className="plan-title">Basic 플랜</h2>
              <div className="plan-price">
                <span className="price-amount">30</span>
                <span className="price-unit">원 / 콜</span>
              </div>
              <p className="plan-description">
                가입 무료 + 사용한 만큼만 지불
              </p>
            </div>

            <div className="plan-features">
              <h3 className="features-title">포함 기능</h3>
              <ul className="features-list">
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">웹 기반 사용</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">수동 업로드 (엑셀/CSV)</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">기본 템플릿 제공</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">TTS 음성 발신 (30원/건)</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">TTS 설문조사 (30원/건)</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">배차 오토콜 (30원/건)</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">대량 문자 발송 (20원/건) 🆕</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">크레딧 선불 결제</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">실시간 발신 현황</span>
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">상세 리포트</span>
                </li>
              </ul>
            </div>

            <Link to="/login" className="btn btn-primary btn-lg">
              지금 시작하기
            </Link>
          </div>
        </div>
      </section>

      {/* VIP Plans */}
      <section className="vip-plans section">
        <div className="container">
          <h2 className="section-title text-center">VIP 서비스 (선택형)</h2>
          <p className="section-subtitle text-center">
            더욱 강력한 기능이 필요하신가요?<br />
            후속 출시 예정인 프리미엄 서비스를 확인해보세요
          </p>

          <div className="vip-grid">
            <div className="vip-card fade-in">
              <div className="vip-badge">Coming Soon</div>
              <div className="vip-icon">📞</div>
              <h3 className="vip-title">VIP 회선 서비스</h3>
              <div className="vip-price">
                <span className="price-monthly">월 50,000원</span>
                <span className="price-per-call">+ 콜당 20원</span>
              </div>
              <p className="vip-description">
                원하는 발신번호로 전화 발송 가능
              </p>
              <ul className="vip-features">
                <li>✓ 전용 발신번호 등록</li>
                <li>✓ 회선 개설 서비스</li>
                <li>✓ 발신자 번호 표시</li>
                <li>✓ 높은 CPS 제한</li>
                <li>✓ 우선 발신 처리</li>
              </ul>
              <button className="btn btn-secondary" disabled>
                준비 중
              </button>
            </div>

            <div className="vip-card fade-in" style={{ animationDelay: '0.2s' }}>
              <div className="vip-badge">Coming Soon</div>
              <div className="vip-icon">🔗</div>
              <h3 className="vip-title">VIP DB 연동</h3>
              <div className="vip-price">
                <span className="price-monthly">월 250,000원</span>
                <span className="price-per-call">+ 콜당 20원</span>
              </div>
              <p className="vip-description">
                ERP 솔루션 DB 연동 자동 발신
              </p>
              <ul className="vip-features">
                <li>✓ ERP 시스템 연동</li>
                <li>✓ 자동 발신 트리거</li>
                <li>✓ 실시간 동기화</li>
                <li>✓ Webhook 지원</li>
                <li>✓ 맞춤형 워크플로우</li>
              </ul>
              <button className="btn btn-secondary" disabled>
                준비 중
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Credit Bonus */}
      <section className="credit-bonus section">
        <div className="container">
          <h2 className="section-title text-center">크레딧 충전 보너스</h2>
          <p className="section-subtitle text-center">
            한 번에 많이 충전할수록 더 많은 보너스!
          </p>

          <div className="bonus-grid">
            <div className="bonus-card">
              <div className="bonus-amount">10,000원</div>
              <div className="bonus-percent">+0%</div>
              <div className="bonus-total">총 10,000원</div>
            </div>
            <div className="bonus-card featured">
              <div className="bonus-badge">추천</div>
              <div className="bonus-amount">50,000원</div>
              <div className="bonus-percent">+5%</div>
              <div className="bonus-total">총 52,500원</div>
            </div>
            <div className="bonus-card">
              <div className="bonus-amount">100,000원</div>
              <div className="bonus-percent">+10%</div>
              <div className="bonus-total">총 110,000원</div>
            </div>
            <div className="bonus-card best">
              <div className="bonus-badge best-badge">최고</div>
              <div className="bonus-amount">500,000원</div>
              <div className="bonus-percent">+20%</div>
              <div className="bonus-total">총 600,000원</div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="pricing-faq section">
        <div className="container-narrow">
          <h2 className="section-title text-center">자주 묻는 질문</h2>

          <div className="faq-list">
            <div className="faq-item">
              <h3 className="faq-question">과금은 언제 되나요?</h3>
              <p className="faq-answer">
                발신 시도 기준으로 1회 과금됩니다. 통화 성공 여부와 관계없이 발신을 시도하면 크레딧이 차감됩니다.
              </p>
            </div>

            <div className="faq-item">
              <h3 className="faq-question">크레딧 유효기간이 있나요?</h3>
              <p className="faq-answer">
                충전한 크레딧은 충전일로부터 1년간 유효합니다. 기간 내 미사용 크레딧은 자동 소멸됩니다.
              </p>
            </div>

            <div className="faq-item">
              <h3 className="faq-question">환불이 가능한가요?</h3>
              <p className="faq-answer">
                충전한 크레딧은 사용하지 않은 경우 충전일로부터 7일 이내 100% 환불 가능합니다.
              </p>
            </div>

            <div className="faq-item">
              <h3 className="faq-question">재발신 시에도 요금이 부과되나요?</h3>
              <p className="faq-answer">
                네, 재발신도 발신 시도이므로 콜당 30원이 부과됩니다. 재발신 횟수는 설정에서 조정할 수 있습니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta section">
        <div className="container text-center">
          <h2 className="cta-title">지금 바로 시작하세요</h2>
          <p className="cta-description">
            합리적인 가격으로 강력한 자동 전화 발신 서비스를 이용하세요
          </p>
          <Link to="/login" className="btn btn-primary btn-lg">
            무료로 시작하기
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
